import { useEffect, useState } from 'react';
import { useMediaQuery } from '../../../helpers/useMediaQuery';
import { Flex, NavButtons, Text, SelectionCard } from '../../../2022-component-library';
import { ResponsiveManualDistance, ResponsivePupillaryDistanceOptician } from '..';
import { useCalibration } from '../../../context/calibrationContext';
import { useTestContext } from '../../../context/testContext';
import { usePostMessage } from '../../../context/messageContext';

const SelectMethod = ({ methodSelected, handleMethodSelection }) => {
  return (
    <Flex column alignItems='center'>
      <Text margin='0.5rem'>{`Select how you want to set the patient's distance from the screen.`}</Text>
      <Flex margin='1rem' justifyContent='space-between' width='100%'>
        <SelectionCard
          onClick={() => {
            handleMethodSelection('faceRecognition');
          }}
          selected={methodSelected === 'faceRecognition'}
        >
          <Text>{`Pupillary Distance`}</Text>
        </SelectionCard>
        <SelectionCard
          onClick={() => {
            handleMethodSelection('manual');
          }}
          selected={methodSelected === 'manual'}
        >
          <Text>{`Input Manually`}</Text>
        </SelectionCard>
        <SelectionCard disabled>
          <Text>{`Use Blindspot`}</Text>
        </SelectionCard>
      </Flex>
    </Flex>
  );
};

const ResponsiveSetDistanceContainer = ({ setActiveTab }) => {
  const { testData, updateTestData } = useTestContext();
  const [methodSelected, setMethodSelected] = useState(testData.methodSelected || 'faceRecognition');
  const smallScreen = useMediaQuery('(max-width: 700px)');
  const { updateCalibrationData } = useCalibration();
  const postMessage = usePostMessage();

  const updateStep = (direction) => {
    if (direction === 'back') return setActiveTab('calibration-selection');
    return setActiveTab('test');
  };

  const handleMethodSelection = (method) => {
    const usingMovementDetection = method === 'faceRecognition';
    setMethodSelected(method);
    updateCalibrationData({ methodSelected: method });
    updateTestData({ testMode: usingMovementDetection ? 'auto' : 'off' });
  };

  useEffect(() => {
    if (methodSelected === 'faceRecognition') return postMessage({ type: 'pupillaryDistance' });
    if (methodSelected !== 'faceRecognition' && methodSelected !== 'blindspot') return postMessage({ type: 'holding' });
  }, [methodSelected, postMessage]);

  return (
    <Flex column alignItems='center' justifyContent={smallScreen ? 'center' : 'flex-start'} height='min(100%, 500px)'>
      <SelectMethod smallScreen={smallScreen} methodSelected={methodSelected} handleMethodSelection={handleMethodSelection} />
      <Flex column centered height='100%'>
        {methodSelected === 'manual' && <ResponsiveManualDistance updateStep={updateStep} setActiveTab={setActiveTab} />}
        {methodSelected === 'faceRecognition' && <ResponsivePupillaryDistanceOptician />}
        {methodSelected !== 'manual' && <NavButtons marginTop='2rem' canProgress={true} updateStep={updateStep} />}
      </Flex>
    </Flex>
  );
};

export default ResponsiveSetDistanceContainer;
